import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Header } from '../../components';

export default function SomethingWentWrong() {
  return (
    <>
      <Header />
      <Container maxW={'3xl'}>
        <Stack
          as={Box}
          textAlign={'center'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 36 }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}>
            <Text as={'span'} color={'red.400'}>
              Something went wrong
            </Text>
          </Heading>
          <Text color={'gray.500'}>
            For some reason, application is not able to connect to the servers.
          </Text>
          <Stack
            direction={'column'}
            spacing={3}
            align={'center'}
            alignSelf={'center'}
            position={'relative'}>
            <Link
              to={{
                pathname: "/",
              }}
            >
              <Button
                colorScheme={'green'}
                bg={'green.400'}
                rounded={'full'}
                px={6}
                _hover={{
                  bg: 'green.500',
                }}>
                Try Again
            </Button>
            </Link>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}